import { IThongKeSoLuongSinhVienRequest } from "../../../model/request/bao-cao/IThongKeSoLuongSinhVienRequest";
import { IThongKeSoLuongSinhVienKetQua } from "../../../model/respone/bao-cao/IThongKeSoLuongSinhVien";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";

export const eThongKeSoLuongSinhVienActionsObj = {
  CHANGE_REQUEST: {} as Partial<IThongKeSoLuongSinhVienRequest>,

  LOAD_START: {} as IThongKeSoLuongSinhVienRequest,
  LOAD_SUCCESS: {} as IThongKeSoLuongSinhVienKetQua,
  LOAD_ERROR: "",

  EXPORT_EXCEL_START: {} as IThongKeSoLuongSinhVienRequest,
  EXPORT_EXCEL_SUCCESS: "",
  EXPORT_EXCEL_ERROR: "",

  /** Xem trước bản in (HTML dựng từ chính tệp Excel sẽ xuất) để in. */
  XEM_TRUOC_START: {} as IThongKeSoLuongSinhVienRequest,
  XEM_TRUOC_SUCCESS: "",
  XEM_TRUOC_ERROR: "",
  DONG_XEM_TRUOC: undefined,
};

export const eThongKeSoLuongSinhVienActionIds = generateActionTypeIds(
  eThongKeSoLuongSinhVienActionsObj,
  "THONG_KE_SL_SINH_VIEN",
);

export type IThongKeSoLuongSinhVienActionTypes = IGenericActionType<
  typeof eThongKeSoLuongSinhVienActionsObj,
  "THONG_KE_SL_SINH_VIEN"
>;
